
import { defineComponent, computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import moment from 'moment-timezone';
import { formatDateToLocale } from '@/helpers/Date';

export default defineComponent({
  name: 'RenderDatetime',
  props: {
    value: {
      type: [String, Date] as PropType<string | Date>,
      required: true,
    },
  },

  setup(props) {
    const { locale } = useI18n();

    const formattedValue = computed(() => {
      if (!props.value) return '';

      const momentDate = moment(props.value);

      if (!momentDate.isValid()) {
        console.warn(`RenderDatetime: Could not parse date value with moment: ${props.value}`);
        return formatDateToLocale(locale.value, String(props.value));
      }

      const dateStringForHelper = momentDate.format('YYYY-MM-DD HH:mm:ss.SSS');

      return formatDateToLocale(locale.value, dateStringForHelper);
    });

    return {
      formattedValue,
    };
  },
});
